import styled from "@emotion/styled/macro";
import { Banner, BannerTypes, Button } from "@sunrun/experience-ui-components";
import { getBlockedValidationDocSigningMessage } from "utils/contactValidation";

type DuplicateValidationWarningBannerProps = {
  validationStatus?: string;
  onViewDetails: () => void;
  viewDetailsTestId?: string;
  actionLabel?: string;
};

const DuplicateValidationWarningBanner = ({
  validationStatus,
  onViewDetails,
  viewDetailsTestId = "duplicate-validation-warning-view-details",
  actionLabel = "View details",
}: DuplicateValidationWarningBannerProps) => {
  const message = getBlockedValidationDocSigningMessage(validationStatus);

  if (!message) {
    return null;
  }

  return (
    <BannerContainer>
      <Banner
        bannerType={BannerTypes.ErrorLight}
        bannerTestId="duplicate-validation-warning-banner"
        title={message}
        show={true}
        showClose={false}
        customButtons={
          <ViewDetailsButton
            size="xs"
            color="tertiary"
            data-testid={viewDetailsTestId}
            onClick={onViewDetails}
          >
            {actionLabel}
          </ViewDetailsButton>
        }
      />
    </BannerContainer>
  );
};

const BannerContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin: 0 !important;
`;

const ViewDetailsButton = styled(Button)`
  text-decoration: underline;
`;

export { DuplicateValidationWarningBanner };
export type { DuplicateValidationWarningBannerProps };
